import AdvocateTrustpilot from './AdvocateTrustpilot';

export default AdvocateTrustpilot;
